import {
  Card,
  CardContent,
  Divider,
  Grid,
  Typography
} from '@material-ui/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { PaymentTermStatus } from '../redux/models/paymentTerms';
import { iRootState } from '../redux/store';
import Installment from './Installment';
import PaymentTotal from './PaymentTotal';
import PaySelectedInstallments from './PaySelectedInstallments';
import QuoteTotal from './QuoteTotal';
import RemainingTotal from './RemainingTotal';
import TermsHeader from './TermsHeader';
import PayTotalQuote from './PayTotalQuote';

const PayInstallments = function PayInstallments(): React.ReactElement {
  const terms = useSelector((state: iRootState) => state.paymentTerms.terms);
  const selectedPaymentsTotal = useSelector(
    (state: iRootState) => state.paymentTerms.selectedPaymentsTotal
  );
  const anyPaid = terms.some(
    t =>
      t.paymentStatus === PaymentTermStatus.Paid ||
      t.paymentStatus === PaymentTermStatus.Pending ||
      t.paymentStatus === PaymentTermStatus.UnderReview
  );
  const anyTermsRemaining =
    terms.filter(
      t =>
        t.paymentStatus === PaymentTermStatus.Due ||
        t.paymentStatus === PaymentTermStatus.Unpaid
    ).length > 0;
  const payShowPayTotal = (
    <Grid>
      <PayTotalQuote />
    </Grid>
  );

  return (
    <Card elevation={1}>
      <CardContent>
        <Typography color='primary' variant='subtitle1'>
          <FormattedMessage
            id='PaymentTerms.PayInstallments'
            defaultMessage='Pay Installments'
          />
        </Typography>
        <Divider />
        <TermsHeader anyPaid={anyPaid} />
        {terms.map(term => (
          <Installment key={term.termOrder} term={term} anyPaid={anyPaid} />
        ))}
        <RemainingTotal />
        <QuoteTotal />
        <Divider />
        <PaymentTotal total={selectedPaymentsTotal} />
        <Grid container justify='center' alignItems='flex-end'>
          <Grid>{anyTermsRemaining && <PaySelectedInstallments />}</Grid>
          {!anyPaid && payShowPayTotal}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default PayInstallments;
